import React, { useEffect, useState } from "react";
import DialogWrapMedium from "../../../controls/components/dialogWrap/DialogWrap";
import { TextField } from "@material-ui/core";
import {
    InputOrderAdminTitle,
    UserFormServiceButtonClose,
    UserFormServiceButtonCreated,
} from "../../MyBooking/styled/DesStyled";
import usePartnerDetail from "../hook/useGetUserDetail";
import http from "../../../../services/http";
import IconButton from "@material-ui/core/IconButton";

export default function DialogTrustItemsPartner(props: {
    openDialog: boolean;
    setOpenDialog: (value: boolean) => void;
    partnerId: string;
    reload: () => void;
}) {
    const { userDetail } = usePartnerDetail({ id: props.partnerId, openDialog: props.openDialog });
    const [trustItems, setTrustItems] = useState<any[]>([
        { text: '' }
    ]);

    useEffect(() => {
        if (props.openDialog && userDetail) {
            const partnerTrustItems = (userDetail as any).trustItems;
            if (partnerTrustItems && Array.isArray(partnerTrustItems)) {
                setTrustItems(partnerTrustItems.length > 0 ? partnerTrustItems : [{ text: '' }]);
            }
        }
    }, [userDetail, props.openDialog]);

    const handleAddItem = () => {
        setTrustItems([...trustItems, { text: '' }]);
    };

    const handleRemoveItem = (index: number) => {
        const newItems = [...trustItems];
        newItems.splice(index, 1);
        setTrustItems(newItems);
    };

    const handleChange = (index: number, value: string) => {
        const newItems = [...trustItems];
        newItems[index] = { ...newItems[index], text: value };
        setTrustItems(newItems);
    };

    const handleSave = async () => {
        try {
            await http.put(`/admin-update-partner-trust-items/${props.partnerId}`, {
                trustItems: trustItems
            });
            props.reload();
            props.setOpenDialog(false);
        } catch (err) {
            console.error("Error updating trust items:", err);
        }
    };

    return (
        <DialogWrapMedium
            login={true}
            open={props.openDialog}
            onClose={() => props.setOpenDialog(false)}
            title="Manage Trust Items"
            actions={
                <>
                    <UserFormServiceButtonClose onClick={() => props.setOpenDialog(false)}>
                        Cancel
                    </UserFormServiceButtonClose>
                    <UserFormServiceButtonCreated onClick={handleSave}>Save</UserFormServiceButtonCreated>
                </>
            }>
            <div>
                <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <strong style={{ fontSize: '16px' }}>Trust Items</strong>
                    <button onClick={handleAddItem} style={{ 
                        padding: '8px 16px', 
                        background: '#2563EB', 
                        color: 'white', 
                        border: 'none', 
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '14px'
                    }}>
                        + Add Item
                    </button>
                </div>
                <div style={{ maxHeight: '400px', overflowY: 'auto', paddingRight: '10px' }}>
                    {trustItems.map((item, index) => (
                        <div key={index} style={{ border: '1px solid #e0e0e0', borderRadius: '8px', padding: '16px', marginBottom: '16px', position: 'relative' }}>
                            <IconButton 
                                onClick={() => handleRemoveItem(index)} 
                                style={{ position: 'absolute', top: '8px', right: '8px', background: '#ef4444', color: 'white', width: '24px', height: '24px', padding: '0' }}
                                size="small"
                            >
                                ×
                            </IconButton>
                            <TextField
                                label={`Item ${index + 1}`}
                                variant="outlined"
                                fullWidth
                                value={item.text}
                                onChange={(e) => handleChange(index, e.target.value)}
                                style={{ marginBottom: '8px' }}
                                placeholder="e.g., 180+ BOUNCE STORAGE SPOTS GLOBALLY"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </DialogWrapMedium>
    );
}

